"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginButton = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_google_login_1 = require("@cs125/react-google-login");
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const useTheme_1 = __importDefault(require("@material-ui/core/styles/useTheme"));
const Google_1 = __importDefault(require("mdi-material-ui/Google"));
const Error_1 = __importDefault(require("@material-ui/icons/Error"));
const ExitToApp_1 = __importDefault(require("@material-ui/icons/ExitToApp"));
const grey_1 = __importDefault(require("@material-ui/core/colors/grey"));
const useStyles = makeStyles_1.default(theme => ({
    wrapper: {
        display: "inline-block",
        position: "relative",
    },
    button: {
        width: "5rem",
        height: theme.spacing(4),
        lineHeight: "normal",
        color: theme.palette.background.default,
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "0.8rem",
        padding: theme.spacing(1),
    },
    iconOnly: {
        width: "3rem",
        minWidth: "3rem",
        fontSize: theme.spacing(3),
    },
    icon: {
        marginBottom: -2,
    },
    success: {
        backgroundColor: theme.palette.success.main,
        "&:hover": {
            backgroundColor: theme.palette.success.light,
        },
    },
    logout: {
        backgroundColor: grey_1.default[500],
        "&:hover": {
            backgroundColor: grey_1.default[700],
        },
    },
    disabled: {
        backgroundColor: grey_1.default[500],
    },
    loading: {
        color: theme.palette.background.default,
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
}));
exports.LoginButton = ({ iconOnly = false, loginText = "Login", ...props }) => {
    const { ready, auth, isSignedIn, err, loggingIn, setLoggingIn } = react_google_login_1.useGoogleLogin();
    const classes = useStyles();
    const theme = useTheme_1.default();
    const loginOrOut = react_1.useCallback((isSignedIn) => async () => {
        if (!auth) {
            return;
        }
        setLoggingIn(true);
        try {
            await (!isSignedIn ? auth.signIn() : auth.signOut());
        }
        finally {
            setLoggingIn(false);
        }
    }, [auth, setLoggingIn]);
    let content, disabled = false, className;
    if (err !== undefined) {
        content = iconOnly ? react_1.default.createElement(Error_1.default, null) : react_1.default.createElement("div", null, "Error");
        disabled = true;
    }
    else if (!ready) {
        content = react_1.default.createElement("div", null);
        disabled = true;
    }
    else if (!isSignedIn) {
        content = iconOnly ? (react_1.default.createElement(Google_1.default, { fontSize: "inherit" })) : (react_1.default.createElement("div", null,
            react_1.default.createElement(Google_1.default, { fontSize: "inherit", className: classes.icon }),
            " ",
            react_1.default.createElement("span", null, loginText)));
        className = classes.success;
    }
    else {
        content = iconOnly ? react_1.default.createElement(ExitToApp_1.default, { fontSize: "inherit" }) : react_1.default.createElement("div", null, "Logout");
        className = classes.logout;
    }
    return (react_1.default.createElement("div", { className: classes.wrapper },
        react_1.default.createElement(Button_1.default, Object.assign({ variant: "contained", disableElevation: className === classes.logout, disabled: disabled, className: `${classes.button} ${className} ${iconOnly ? classes.iconOnly : ""}`.trim(), onClick: !err && ready && !loggingIn
                ? loginOrOut(isSignedIn)
                : () => {
                    return;
                } }, props), content),
        (loggingIn || (!ready && !err)) && (react_1.default.createElement(CircularProgress_1.default, { size: theme.spacing(3), thickness: 5, className: classes.loading }))));
};
exports.LoginButton.propTypes = {
    iconOnly: prop_types_1.default.bool,
    loginText: prop_types_1.default.string,
};
exports.LoginButton.defaultProps = {
    iconOnly: false,
    loginText: "Login",
};
//# sourceMappingURL=LoginButton.js.map